/* The five statuses an Event moves between — from `glossary.md`.
 *
 * **This lives in the domain, and `packages/contracts` re-exports it.** It was
 * declared in the contract first, which had the dependency pointing outward:
 * an Event's lifecycle is a business rule and the wire format is a boundary
 * concern, so the boundary should name the domain and not the reverse
 * — `architecture.md`. Nothing about the statuses changed in the move, and the
 * contract's export keeps its name, so no consumer of it noticed.
 *
 * The reason it had to move is STORY-024: the dashboard partitions these five
 * into counted buckets, and that partition is a rule with a test. A rule that
 * cannot be expressed in the domain because the domain cannot see the values
 * is a rule that ends up in a query.
 *
 * Moving between them is STORY-012.
 */
export const EVENT_STATUSES = ['idea', 'planned', 'confirmed', 'completed', 'cancelled'];
//# sourceMappingURL=event-status.js.map